module.exports = __webpack_public_path__ + "src/assets/img/share/tips/open/db8b5bfbd0999b28674ad93cc4e7e5fb.png";